import { PLATFORM_PUBLIC_URL } from "@/shared/environmentVariables";

let INSTRUMENT_URL = `${PLATFORM_PUBLIC_URL}/instrument`;
// INSTRUMENT_URL = `http://localhost:3037/api/v1/no_auth/instrument`; // todo develop: for develop

interface VerifyResponse {
  valid: boolean;
  alreadyOnboarded?: boolean;
  companyName?: string;
  fullName?: string;
  redirectPath?: string | null;
  customToken?: string;
}

/**
 * Проверяет ссылку, получаем customToken
 * @param token
 * @returns
 * http://localhost:3037/api/v1/no_auth/instrument/check-link?token=...
 */
export async function checkSectionOfInstrument(
  token: string,
): Promise<VerifyResponse> {
  const response = await fetch(
    `${INSTRUMENT_URL}/check-link?token=${encodeURIComponent(token)}`,
  );

  if (!response.ok) {
    throw new Error(`Verification failed: ${response.status}`);
  }

  return response.json();
}
